import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';

import { getUnlockStatusIcon } from 'features/views/unlockedClients/utils';
import { equalOrThreeDashes, stringToDate } from 'utils';

const UnlockedClientsTableRow = ({ record }) => {
	const {
		businessName,
		firstName,
		surname,
		personIn,
		businessIn,
		birthDate,
		unlockChannel,
		unlockedFrom,
		unlockedTo,
		extendedFrom,
		extendedTo,
	} = record;

	return (
		<>
			<TableCell>{businessName ? businessName : `${surname} ${firstName}`}</TableCell>
			<TableCell>
				<div>{equalOrThreeDashes(personIn)}</div>
				<div>{equalOrThreeDashes(businessIn)}</div>
			</TableCell>
			<TableCell>{equalOrThreeDashes(stringToDate(birthDate))}</TableCell>
			<TableCell>{unlockChannel}</TableCell>
			<TableCell>
				<div>{stringToDate(unlockedFrom)}</div>
				<div>{stringToDate(unlockedTo)}</div>
			</TableCell>
			<TableCell>
				<div>{equalOrThreeDashes(stringToDate(extendedFrom))}</div>
				<div>{equalOrThreeDashes(stringToDate(extendedTo))}</div>
			</TableCell>
			<TableCell>{getUnlockStatusIcon(extendedTo, unlockedTo)}</TableCell>
		</>
	);
};
UnlockedClientsTableRow.propTypes = {
	record: PropTypes.object,
};

export default UnlockedClientsTableRow;
